import { Grid } from '@material-ui/core';
import React from 'react';
import { IBRMInputDataRequiredInput } from 'src/common/api/brm/brm-utils';
import BaseButton from 'src/common/components/base-button';
import { styles } from './input-data-required-yesno-buttons-styles';

type Props = IInputDataButtonState;

const InputDataButtons: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = styles();
  const { onCancel, onAccept } = props;

  return (
    <Grid container className={classes.dialogContent} wrap='nowrap' justifyContent='space-between'>
      <Grid item>
        <BaseButton
          className={classes.closeButton}
          data-testid='input-data-cancel'
          buttonType='white'
          onClick={onCancel}
        >
          CANCEL
        </BaseButton>
      </Grid>
      <Grid item>
        <BaseButton
          className={classes.acceptButton}
          data-testid='input-data-accept'
          onClick={() =>
            onAccept({
              fieldName: props.inputName,
              value: 'Yes',
            })
          }
        >
          YES
        </BaseButton>
        <BaseButton
          className={classes.rejectButton}
          data-testid='input-data-reject'
          onClick={() =>
            onAccept({
              fieldName: props.inputName,
              value: 'No',
            })
          }
        >
          NO
        </BaseButton>
      </Grid>
    </Grid>
  );
};

interface IInputDataButtonState {
  onCancel: () => void;
  onAccept: (inputData: IBRMInputDataRequiredInput) => void;
  inputName?: string;
}
export default InputDataButtons;
